<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      class="selectForm"
      size="small"
      :inline="true"
      label-width="auto"
    >
      <el-button class="line-button" plain icon="el-icon-plus" @click="handleAddList">新增字典</el-button>
      <!-- <el-button
        plain
        icon="el-icon-upload2"
        class="export-button"
        size="mini"
        @click="handleExport"
      >导出</el-button>-->
    </el-form>

    <div class="card-wrapper"></div>
    <div class="left-right">
      <div class="left">
        <div class="left-title">
          <span>字典类型</span>
          <el-button class="addBtn" plain @click="handleAdd">新增</el-button>
        </div>
        <el-input
          v-model="queryParams.dictName"
          placeholder="请输入字典类型"
          clearable
          @clear="clear"
          @keyup.enter.native="handleQuery"
        />
        <ul class="list">
          <li>
            <div class="content" :class="{ active: active == '全部' }" @click="toAll">全部</div>
          </li>
          <li
            v-for="(item, index) in listCard"
            :key="item.dictName"
            @click="handleActive(item, index)"
          >
            <div class="content" :class="{ active: active == item.dictName }">{{ item.dictName }}</div>
            <div class="operation">
              <img src="@/assets/edit.png" @click.stop="handleUpdate(item)" alt />
              <img src="@/assets/Union.png" @click.stop="handleDelete(item)" alt />
            </div>
          </li>
        </ul>
      </div>

      <div class="right">
        <el-table
          class="listTable"
          :data="list"
          border
          :default-sort="{ prop: 'dictType', order: 'descending' }"
          v-loading="tableLoading"
          :max-height="700"
          ref="containTable"
        >
          <el-table-column label="序号" type="index" width="200" />
          <el-table-column label="字典类型键名" prop="dictType" :show-overflow-tooltip="true" />
          <el-table-column label="键名" prop="dictLabel" :show-overflow-tooltip="true" />
          <el-table-column label="键值" prop="dictValue" :show-overflow-tooltip="true" />
          <!-- <el-table-column label="备注" prop="remark" :show-overflow-tooltip="true" /> -->
          <el-table-column label="状态" prop="status" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span
                :style="{ color: scope.row.status == 0 ? 'green' : 'red' }"
              >{{ formatter.status[scope.row.status] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button class="editBtn" type="text" @click="handleUpdateList(scope.row)">修改</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button class="delBtn" type="text" @click="handleDeleteList(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 添加或修改菜单对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="open"
      width="500px"
      append-to-body
      :fullscreen="mFullscreen"
      :before-close="cancel"
      :show-close="false"
      :top="'5vh'"
      :close-on-click-modal="false"
    >
      <div slot="title">
        <DialogHead :title="title" :mFullscreen.sync="mFullscreen" @cancel="cancel"></DialogHead>
      </div>
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">字典类型信息</div>
        </div>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="auto">
        <el-form-item label="名称" prop="dictName">
          <el-input placeholder="请输入名称" v-model="form.dictName"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="dictType">
          <el-input placeholder="请输入类型" v-model="form.dictType"></el-input>
        </el-form-item>
        <!-- <el-collapse v-model="activeName"> -->
        <!-- <el-collapse-item name="active"> -->
        <el-form-item label="状态" prop="status">
          <div class="groupRight">
            <el-radio-group v-model="form.status">
              <el-radio label="0">正常</el-radio>
              <el-radio label="1">停用</el-radio>
            </el-radio-group>
          </div>
          <div class="divclear"></div>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            placeholder="300字以内"
            :maxlength="300"
            type="textarea"
            :rows="2"
            v-model="form.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加或修改菜单对话框 -->
    <el-dialog
      :title="titleList"
      :visible.sync="openList"
      width="600px"
      append-to-body
      :before-close="cancelList"
      :fullscreen="mFullscreen"
      :show-close="false"
      :top="'5vh'"
      :close-on-click-modal="false"
    >
      <div slot="title">
        <DialogHead :title="titleList" :mFullscreen.sync="mFullscreen" @cancel="cancelList"></DialogHead>
      </div>
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">字典信息</div>
        </div>
      </div>
      <el-form
        label-position="left"
        ref="formList"
        :model="formList"
        :rules="rulesList"
        label-width="auto"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="字典类型" prop="dictType">
              <el-input placeholder="请输入字典类型" v-model="formList.dictType"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="键名" prop="dictLabel">
              <el-input placeholder="请输入键名" v-model="formList.dictLabel"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="键值" prop="dictValue">
              <el-input placeholder="请输入键值" v-model="formList.dictValue"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="样式" prop="listClass">
              <el-radio-group v-model="formList.listClass">
                <el-radio label>默认</el-radio>
                <el-radio label="primary">主要</el-radio>
                <el-radio label="success">成功</el-radio>
                <el-radio label="warning">警告</el-radio>
                <el-radio label="danger">危险</el-radio>
                <el-radio label="info">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>-->
          <el-col :span="24">
            <!-- <el-form-item label="是否默认" prop="isDefault">
              <div class="groupRight">
                <el-radio-group v-model="formList.isDefault">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </div>
              <div class="divclear"></div>
            </el-form-item>-->
            <el-form-item label="状态" prop="status">
              <div class="groupRight">
                <el-radio-group v-model="formList.status">
                  <el-radio label="0">正常</el-radio>
                  <el-radio label="1">停用</el-radio>
                </el-radio-group>
              </div>
              <div class="divclear"></div>
            </el-form-item>
            <!-- <el-col :span="8"> -->
            <!-- </el-col> -->
            <el-form-item label="备注" prop="remark">
              <el-input
                placeholder="300字以内"
                :maxlength="300"
                type="textarea"
                :rows="2"
                v-model="formList.remark"
              ></el-input>
            </el-form-item>
            <!-- </el-collapse-item> -->
            <!-- </el-collapse> -->
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="batch-button" @click="cancelList">取 消</el-button>
        <el-button class="line-button" type="primary" @click="submitFormList">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { getToken } from '@/utils/auth'
// import {
//   isNumber,
//   isPhone,
//   validText,
//   message,
//   validIdCard,
//   isImg,
// } from '@/utils/validate'

// import { getCard, getCardById, add, put, del } from '@/api/system/dict/card'

// import {
//   getList,
//   getListById,
//   addList,
//   putList,
//   delList,
// } from '@/api/system/dict/list'
// import Mixins from '@/mixins'
import DialogHead from '@/components/innerDialogHead.vue'
import {
  dictType,
  dictTypeList,
  dictDataList,
  addDictDataList,
  editDictData,
  deleteDictData,
  editDictType,
  deleteDictType,
} from '@/api/system/system'
export default {
  name: 'Serve',
  components: { DialogHead },
  // mixins: [Mixins],
  // watch: {
  //   'list.length'(newLength) {
  //     console.log('数组长度已经改变了', newLength)
  //     this.estimateTableHeight(newLength)
  //   },
  // },
  data() {
    // const validateText = (rule, value, callback) => {
    //   // console.log(value);
    //   // console.log(value.length);
    //   if (value) {
    //     // console.log(222);
    //     if (value.length > 20) {
    //       callback(new Error("密码不能少于 6 位"));
    //       // console.log(333);
    //       } else {
    //       // console.log(444);
    //         callback();
    //     }
    //   } else {
    //     // console.log(111);
    //       callback(new Error("内容不能为空"));
    //   }
    // };
    // const validTxtLength = this.validTxtLength(30)
    return {
      mFullscreen: false,
      tableLoading: false,
      //   isActive: 'all',
      // 查询参数
      // dictType:字典类型键名,dictLabel:键名,dictValue:键值,status:状态
      filename: '字典管理',
      colLists: [
        { label: '字典类型键名', prop: 'dictType' },
        { label: '键名', prop: 'dictLabel' },
        { label: '键值', prop: 'dictValue' },
        { label: '状态', prop: 'status' },
      ],
      queryParams: {
        // pageNum: 1,
        // pageSize: 10,
        dictName: null,
        // status: null,
        // tenantId: null,
      },
      queryParamsList: {
        // pageNum: 1,
        // pageSize: 10,
        dictType: null,
        // status: null,
        // tenantId: null,
      },
      // 字典表格数据
      listCard: [],
      list: [],
      formatter: {
        status: { 0: '正常', 1: '停用' },
      },
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 弹出层标题
      titleList: '',
      // 是否显示弹出层
      openList: false,
      titleSee: '',
      see: false,
      //   total: 0,
      // 表单参数
      form: { remark: '' },
      formList: { remark: '' },
      upHeaders: '',
      // { Authorization: 'Bearer ' + getToken() },
      /** 新增或修改弹窗 */
      activeName: 'active',
      // 表单参数
      // active: 0,
      active: '全部',
      // 表单校验
      rules: {
        dictName: [{ required: true, message: '请输入', trigger: 'blur' }],
        // password: [
        //   { required: true, trigger: "blur", validator: validatePassword },
        // ],
        dictType: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      rulesList: {
        // dictType: null, // 字典类型
        // dictLabel: null, // 键名
        // dictValue: null, // 键值
        // dictSort: null, // 排序
        // isDefault: null, // 是否默认
        // listClass: null, // 样式
        dictType: [{ required: true, trigger: 'blur' }],
        dictLabel: [{ required: true, message: '请输入键名', trigger: 'blur' }],
        dictValue: [{ required: true, message: '请输入键值', trigger: 'blur' }],
        // dictLabel: [{ required: true, validator: isPhone, trigger: "blur" }],
        // userId: [{ required: false, validator: isNumber, trigger: "blur" }],
        // duty: [{ required: false, validator: validText(30), trigger: "blur" }],
        // idNumber: [
        //   { required: false, validator: validIdCard, trigger: "blur" },
        // ],
        // formal: [{ required: false, validator: validText(8), trigger: "blur" }],
        // nativePlace: [
        //   { required: false, validator: validText(30), trigger: "blur" },
        // ],
        // remark: [
        //   { required: false, validator: validText(30), trigger: "blur" },
        // ],
      },
      upload: {
        action: process.env.VUE_APP_BASE_API + '/file/upload',
        headers: '',
        //  { Authorization: 'Bearer ' + getToken() },
      },
    }
  },
  created() {
    this.getCardAll()
    this.getListAll()
  },
  methods: {
    /** 查询字典列表 */
    getCardAll() {
      dictTypeList(this.queryParams)
        .then((res) => {
          console.log(res, 'resresresresresres-----------------')
          if (res.flag) {
            this.listCard = res.data
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    toAll() {
      this.active = '全部'
      this.queryParamsList.dictType = null
      this.getListAll()
    },
    getListAll() {
      if (this.active != '全部') {
        this.listCard.some((item, index) => {
          if (item.dictName == this.active) {
            this.queryParamsList.dictType = this.listCard[index].dictType
          }
        })
      }
      this.tableLoading = true
      // this.queryParamsList.deptId = this.listCard[this.active].deptId;
      dictDataList(this.queryParamsList)
        .then((res) => {
          this.tableLoading = false
          console.log(res, 'resresresresresres-----------------')
          if (res.flag) {
            this.list = res.data
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          this.tableLoading = false
          console.log(error)
        })
    },
    handleActive(item, index) {
      console.log('是调了这个-------------')
      this.active = item.dictName // 字典类型
      // this.listCard.forEach((item) => {
      //   item.isActive = false
      // })
      // item.isActive = true
      // console.log(this.active);
      // console.log(index);
      //   if (this.active == index) {
      //     this.active = null;
      //     this.queryParamsList.dictType = null;
      //     // this.resetForm("queryForm");

      //     // this.getListAll();
      //   } else {
      //   this.active = item.dictName;
      // this.getListAll();
      //   }
      this.getListAll()
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // this.queryParams.pageNum = 1;
      this.getCardAll()
    },
    /** 重置按钮操作 */
    // resetQuery() {
    //   this.resetForm('queryForm');
    //   this.handleQuery();
    // },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.open = true
      this.title = '新增字典类型'
    },
    handleAddList() {
      if (this.active == '全部') {
        return this.$message({
          message: '请选择字典类型',
          type: 'warning',
        })
      }
      this.resetList()
      this.listCard.some((item) => {
        if (item.dictName == this.active) {
          this.formList.dictType = item.dictType
        }
      })

      this.openList = true
      this.titleList = '新增字典'
    },
    // 取消按钮
    cancel() {
      console.log(this.listCard, '-----------------取消')
      this.mFullscreen = false
      this.open = false
      this.reset()
    },
    cancelList() {
      this.mFullscreen = false
      this.openList = false
      this.resetList()
    },
    // cancelSee() {
    //   this.see = false;
    //   // this.resetList();
    // },
    handleAvatarSuccessProfile(file) {
      this.formList.profile = file.data.url
    },
    handleAvatarSuccessIdFront(file) {
      this.formList.idFrontImg = file.data.url
    },
    handleAvatarSuccessIdReverse(file) {
      this.formList.idReverseImg = file.data.url
    },
    // 表单重置
    reset() {
      this.form = {
        dictName: null,
        dictType: null,
        // leader: null,
        status: '0',
        remark: '',
      }
      this.resetForm('form')
    },
    resetList() {
      this.formList = {
        dictLabel: null,
        dictValue: null,
        dictType: null,
        status: '0',
        remark: '',
      }
      this.resetForm('formList')
    },
    /** 修改按钮操作 */
    handleUpdate(item) {
      // console.log(item);
      this.reset()
      // const id = item.dictId
      console.log(item, 'item-----------------------')
      for (let key in item) {
        this.form[key] = item[key]
      }
      this.open = true
      this.title = '修改字典类型'
    },
    /** 修改按钮操作 */
    handleUpdateList(row) {
      this.resetList()
      // const id = row.dictCode
      this.formList = this.deepClone(row)
      this.openList = true
      this.titleList = '修改字典'
      // getListById(id).then((response) => {

      // })
    },
    // handleSeeList(row) {
    //   this.resetList()
    //   const id = row.id
    //   getListById(id).then((response) => {
    //     // console.log(response);
    //     this.formList = response.data.data
    //     this.see = true
    //     this.titleSee = '查看字典'
    //   })
    // },
    /** 导出按钮操作 */
    handleExport() {
      // const exportList = this.list.map((data, i) => {
      //   var obj = { index2: i + 1 }
      //   this.colLists.forEach((d, i) => {
      //     obj[d.prop] = data[d.prop]
      //   })
      //   obj.status = this.formatter.status[data.status]
      //   return {
      //     ...obj,
      //   }
      // })
      // if (exportList.length == 0) {
      //   this.$message.warning('数据为空，请先搜索再导出')
      //   return
      // }
      // console.log(exportList, 'exportList')
      // var arr = [this.filename]
      // var arr2 = ['序号']
      // var arr3 = ['index2']
      // this.colLists.forEach((d, i) => {
      //   if (d.label !== '操作') {
      //     arr.push('')
      //     arr2.push(d.label)
      //     arr3.push(d.prop)
      //   }
      // })
      // console.log(arr, arr2, arr3, 'arr3')
      // import('@/vendor/Export2Excel').then((excel) => {
      //   const multiHeader = [arr, arr2]
      //   const filterVal = arr3
      //   const data = this.formatJson(filterVal, exportList)
      //   const merges = ['A1:E1']
      //   excel.export_json_to_excel({
      //     title: [this.filename],
      //     multiHeader,
      //     data,
      //     merges,
      //     filename: this.filename,
      //   })
      // })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // console.log(row);
      const ids = row.dictId
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return deleteDictType(ids)
        })
        .then((res) => {
          console.log(res, 'resresresresresres-----------------')
          if (res.flag) {
            this.active = '全部'
            this.getListAll()
            this.getCardAll()
            this.$message.success('操作成功')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleDeleteList(row) {
      const ids = row.dictCode
      // console.log(row);
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return deleteDictData(ids)
        })
        .then((res) => {
          console.log(res, 'resresresresresres-----------------')
          if (res.flag) {
            this.getListAll()
            this.getCardAll()
            this.$message.success('操作成功')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          // console.log(this.form);
          if (this.form.dictId) {
            editDictType(this.form)
              .then((res) => {
                console.log(res, 'resresresresresres-----------------')
                if (res.flag) {
                  this.$message.success('操作成功')
                  this.getCardAll()
                  this.open = false
                  console.log(this.tableData, 'this.tableDatathis.tableData--------------')
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                console.log(error)
              })
          } else {
            dictType(this.form)
              .then((res) => {
                console.log(res, 'resresresresresres-----------------')
                if (res.flag) {
                  this.$message.success('操作成功')
                  this.getCardAll()
                  this.open = false
                  console.log(this.tableData, 'this.tableDatathis.tableData--------------')
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                console.log(error)
              })
          }
        }
      })
    },
    submitFormList() {
      this.$refs['formList'].validate((valid) => {
        if (valid) {
          if (this.formList.dictCode) {
            // /system/dict/type
            editDictData(this.formList)
              .then((res) => {
                console.log(res, 'resresresresresres-----------------222')
                if (res.flag) {
                  this.$message.success('操作成功')
                  this.openList = false
                  this.getListAll()
                  this.getCardAll()
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                console.log(error)
              })
          } else {
            // console.log(this.listCard[this.active]);
            // this.formList.deptId = this.listCard[this.active].deptId;
            addDictDataList(this.formList)
              .then((res) => {
                console.log(res, 'resresresresresres-----------------')
                if (res.flag) {
                  this.$message.success('操作成功')
                  this.openList = false
                  this.getListAll()
                  this.getCardAll()
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                console.log(error)
              })
          }
        }
      })
    },
    // 清空
    clear() {
      this.queryParams.dictName = null
      this.queryParamsList.dictType = null
      this.getCardAll()
      this.getListAll()
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/form.less';
@import '~@/assets/style/innerDialog.less';
// @import 'src/assets/styles/newTable';
// @import 'src/assets/styles/form.scss';
::v-deep {
  .listTable {
    border: 2px solid #ebeffa;
    // border-top-right-radius: 16px;
    // border-top-left-radius: 16px;
    // border-bottom-width: 1px;
    border-radius: 16px;

    &::before {
      display: none;
    }

    &::after {
      display: none;
    }
  }
  .el-table__footer-wrapper {
    margin-top: 0px;
  }
  .el-table__cell {
    border-right: none;
  }
  .el-table__header-wrapper {
    border-radius: 16px 16px 0px 0px;
  }
  .el-table th.el-table__cell {
    background: #ece4ce;
    color: #282c38;
    font-size: 14px;
    .cell {
      border-right: 1px solid #cfcff4;
    }
  }
  .el-table .el-table__cell {
    text-align: left;
  }
  // 分页
  .pagination {
    //padding-right: 60px;
    height: 44px;
    // position: fixed;
    right: 15px;
    bottom: 20px;
    .el-pagination {
      display: -moz-box;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flexbox;
      display: flex;

      -webkit-box-pack: right;
      -ms-justify-content: right;
      -moz-justify-content: right;
      -o-justify-content: right;
      -webkit-justify-content: right;
      justify-content: right;

      -webkit-box-align: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -webkit-align-items: center;
      align-items: center;

      height: 100%;
      padding: 0;
    }

    // 上一页
    .btn-prev,
    .btn-next {
      width: 100px;
      height: 100%;
      border-radius: 12px;

      .el-icon {
        text-align: center;
        margin: auto;
        font-size: 14px;

        &::before {
          width: 3px;
          height: 10px;
          font-size: 16px;
          content: '<';
          color: #d3d6e4;
        }

        &::after {
          content: '上一页';
          color: #ffffff;
          margin-left: 5px;
        }
      }
    }

    .btn-prev {
      background-color: #b7b7b7;

      .el-icon {
        &::before {
          width: 3px;
          height: 10px;
          font-size: 16px;
          content: '<';
          color: #d3d6e4;
        }

        &::after {
          content: '上一页';
          color: #ffffff;
          margin-left: 5px;
        }
      }
    }

    .btn-next {
      background-color: #c59429;

      .el-icon {
        &::after {
          width: 3px;
          height: 10px;
          font-size: 16px;
          content: '>';
          color: #d3d6e4;
        }

        &::before {
          content: '下一页';
          color: #ffffff;
          margin-right: 5px;
          font-size: 14px;
        }
      }
    }

    .el-pager {
      display: flex;
      align-items: center;
      height: 100%;
      background-color: #e3e4eb;
      border-radius: 12px;

      .number {
        width: 40px;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        background-color: #e3e4eb;
      }

      .active {
        background-color: #ffffffeb !important;
        border-radius: 12px;
        color: black !important;
      }
    }
  }
}
.export-button {
  border: 1px solid #c59429;
  color: #c59429;
}
.import-button {
  border: 1px solid #c59429;
  color: #c59429;
}
/*@import '@/assets/styles/card-wrapper.scss';
@import '@/assets/styles/table.scss';
@import '@/assets/styles/dialog.scss';

@import '@/assets/styles/newIndex';*/
.app-container {
  .title {
    font-weight: 700;
    font-size: 16px;
    color: #141518;
    margin: 20px 0px;
  }

  .line-button {
    background-color: #c59429;
    color: #ffffff;
    border-color: #c59429;
    border-radius: 12px;
  }
}

.el-button {
  // height: 40px;
  border-radius: 12px;
}
.right {
  margin-top: 10px;
  .list-table.el-table {
    height: 700px !important;
  }
}
.left-right {
  display: flex;
  justify-content: left;
  .left {
    width: 220px;
    height: 734px;
    background-color: rgba(241, 241, 241, 0.5);
    margin: 10px 20px 0 0;
    padding: 10px;
    border-radius: 16px;
    flex-shrink: 0;
    border: 1px solid #dde4ff;
    .left-title {
      border-bottom: 1px solid #cfcff4;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0 10px;
      margin-bottom: 16px;
      span {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #1e1f25;
      }
      .addBtn {
        width: 60px;
        height: 32px;
        background: #c59429;
        border-radius: 8px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .list {
      height: calc(100vh - 35vh);
      padding: 0;
      margin: 0;
      list-style: none;
      overflow-y: scroll;
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 16px 0;
        cursor: pointer;
        .content {
          width: 125px;
          white-space: nowrap;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 14px;
        }
        .active {
          color: #c59429;
        }
        .operation {
          display: flex;
          img:first-child {
          }
          img:last-child {
            margin-left: 10px;
          }
        }
      }
    }

    ::-webkit-scrollbar {
      width: 10px;
      // background-color: #f8f8f8;
    }
    ::-webkit-scrollbar-thumb {
      height: 10px;
      background-color: #cfcff4;
    }
  }
  .right {
    flex: 1;
  }
}

.groupRight {
  position: absolute;
  right: 0;
}
.divclear {
  clear: both;
  width: 0;
  height: 0;
}

.editBtn {
  color: #2f4cdd;
}
.delBtn {
  color: #fa2245;
}
</style>
